export const HIT_INVITE_MEMBER = 'HIT_INVITE_MEMBER';
export const GET_INVITE_MEMBER = 'GET_INVITE_MEMBER';

export const HIT_LIST_MEMBER = 'HIT_LIST_MEMBER';
export const GET_LIST_MEMBER = 'GET_LIST_MEMBER';

export const HIT_DETAIL_COMPANY = 'HIT_DETAIL_COMPANY';
export const GET_DETAIL_COMPANY = 'GET_DETAIL_COMPANY';

export const HIT_UPDATE_CP = 'HIT_UPDATE_CP';
export const GET_UPDATE_CP = 'GET_UPDATE_CP';

export const HIT_ACTIVITY_LIST = 'HIT_ACTIVITY_LIST';
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';
export const HIT_ACTIVITY_TYPE_CREATE = 'HIT_ACTIVITY_TYPE_CREATE';
export const HIT_ACTIVITY_TYPE_UPDATE = 'HIT_ACTIVITY_TYPE_UPDATE';
export const HIT_ACTIVITY_MOVE_ORDER = 'HIT_ACTIVITY_MOVE_ORDER';

// settings - custom org parameter
export const HIT_COP_LIST = 'HIT_COP_LIST';
export const GET_COP_LIST = 'GET_COP_LIST';

export const HIT_COP_CREATE = 'HIT_COP_CREATE';
export const HIT_COP_UPDATE = 'HIT_COP_UPDATE';
export const HIT_COP_DELETE = 'HIT_COP_DELETE';
// settings - custom org parameter

export const HIT_CUSTOM_MANAGEMENT = 'HIT_CUSTOM_MANAGEMENT';
export const GET_CUSTOM_MANAGEMENT = 'GET_CUSTOM_MANAGEMENT';
export const HIT_CUSTOM_MANAGEMENT_CREATE = 'HIT_CUSTOM_MANAGEMENT_CREATE';
export const GET_CUSTOM_MANAGEMENT_CREATE = 'GET_CUSTOM_MANAGEMENT_CREATE';
export const HIT_CUSTOM_MANAGEMENT_UPDATE = 'HIT_CUSTOM_MANAGEMENT_UPDATE';
export const GET_CUSTOM_MANAGEMENT_UPDATE = 'GET_CUSTOM_MANAGEMENT_UPDATE';

export const HIT_COMPETENCY_LIB = 'HIT_COMPETENCY_LIB';
export const GET_COMPETENCY_LIB = 'GET_COMPETENCY_LIB';
export const HIT_COMPETENCY_LIB_CREATE = 'HIT_COMPETENCY_LIB_CREATE';
export const GET_COMPETENCY_LIB_CREATE = 'GET_COMPETENCY_LIB_CREATE';
export const HIT_COMPETENCY_LIB_UPDATE = 'HIT_COMPETENCY_LIB_UPDATE';
export const GET_COMPETENCY_LIB_UPDATE = 'GET_COMPETENCY_LIB_UPDATE';
export const HIT_COMPETENCY_IMPORT = 'HIT_COMPETENCY_IMPORT';
export const GET_COMPETENCY_IMPORT = 'GET_COMPETENCY_IMPORT';
export const HIT_COMPETENCY_INQUIRY = 'HIT_COMPETENCY_INQUIRY';
export const GET_COMPETENCY_INQUIRY = 'GET_COMPETENCY_INQUIRY';
export const HIT_COMPETENCY_DELETE = 'HIT_COMPETENCY_DELETE';
export const GET_COMPETENCY_DELETE = 'GET_COMPETENCY_DELETE';

// setting level description
export const HIT_LIST_LEVEL_DESCRIPTION = 'HIT_LIST_LEVEL_DESCRIPTION';
export const GET_LIST_LEVEL_DESCRIPTION = 'GET_LIST_LEVEL_DESCRIPTION';
export const HIT_CREATE_LEVEL_DESCRIPTION = 'HIT_CREATE_LEVEL_DESCRIPTION';
export const HIT_UPDATE_LEVEL_DESCRIPTION = 'HIT_UPDATE_LEVEL_DESCRIPTION';

// setting FTE Limit
export const HIT_FTE_LIMIT_MOVE_ORDER = 'HIT_FTE_LIMIT_MOVE_ORDER';

export const HIT_COMPETENCY_MOVE = 'HIT_COMPETENCY_MOVE';

// Skill Group Management
export const HIT_LIST_SKILL_GROUP = 'HIT_LIST_SKILL_GROUP';
export const GET_LIST_SKILL_GROUP = 'GET_LIST_SKILL_GROUP';
export const HIT_LIST_SUB_SKILL_GROUP = 'HIT_LIST_SUB_SKILL_GROUP';
export const GET_LIST_SUB_SKILL_GROUP = 'GET_LIST_SUB_SKILL_GROUP';
export const GET_LIST_SUB_SKILL_GROUP_MULTIPLE = 'GET_LIST_SUB_SKILL_GROUP_MULTIPLE';
export const GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE = 'GET_UPDATE_SUB_SKILL_GROUP_MULTIPLE';
export const HIT_ACTION_SKILL_GROUP = 'HIT_ACTION_SKILL_GROUP';
export const HIT_DETAIL_COMPETENCY = 'HIT_DETAIL_COMPETENCY';
export const GET_DETAIL_COMPETENCY = 'GET_DETAIL_COMPETENCY';
